import { QuestionOption } from '@estercare/ester-shared'
import { OptionButton } from '../buttons/OptionButton'

type Props = {
  options: Array<QuestionOption & { isSelected: boolean }>
  setAnswer: (options: string[]) => void
}

export const MultipleOptionsSingleSelect = ({ options, setAnswer }: Props) => {
  return options.map((option) => (
    <OptionButton
      key={option.id}
      onClick={() => setAnswer([option.id])}
      option={option.text}
      type="singleOption"
      selected={option.isSelected}
    />
  ))
}
